export default __webpack_public_path__ + "media/images/images/icons/spinner-4b01ca501fadf65135bfa7c8cc1cbc43.gif";